import React, { useEffect, useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  AutocompleteInput,
  useNotify,
  useRedirect,
  useUpdate,
  useDataProvider,
  //useFormContext,
} from "react-admin";
import Box from "@mui/material/Box";

const MenuEdit: React.FC = () => {
  const dataProvider = useDataProvider();

  const [parentMenus, setParentMenus] = useState<any[]>([]);
  //const [actions, setActions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const notify = useNotify();
  const redirect = useRedirect();
  const [update] = useUpdate();

  useEffect(() => {
    Promise.all([
      dataProvider.getList("permissionMenus", {
        pagination: { page: 1, perPage: 10000 },
        sort: { field: "id", order: "ASC" },
        filter: {},
      }),
      dataProvider.getList("permissionActions", {
        pagination: { page: 1, perPage: 10000 },
        sort: { field: "id", order: "ASC" },
        filter: {},
      }),
    ])
      .then(([menusRes, actionsRes]) => {
        setParentMenus(menusRes.data);
        //setActions(actionsRes.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [dataProvider]);

  if (loading) return <span>Loading...</span>;

  const handleSave = async (data: any) => {
    // try {
    //   await update("menus", { id: data.id, data });
    //   notify("Menu Updated", { type: "info" });
    //   redirect("list", "menus");
    // } catch (error) {
    //   notify("Update Failed", { type: "error" });
    // }
        const slug = (s: string) =>
     s
       .toString()
        .trim()
        .replace(/^\//, '')
        .replace(/\s+/g, '-')
        .toLowerCase();

    const normalizePath = (p: string) => {
      if (!p) return '';
     let res = p.trim();
      if (!res.startsWith('/')) res = '/' + res;
     return res.replace(/\/+/g, '/');
    };

try {
  // 验证 parentId 是否仍存在，若不存在则清空
  let parentId = data.parentId;
  if (parentId !== null && parentId !== undefined) {
    const parentExists = parentMenus.some((m) => String(m.id) === String(parentId));
    if (!parentExists) {
      console.warn(`Parent menu id ${parentId} no longer exists, clearing parentId`);
      parentId = null;
    }
  }
  // const parentId = data.parentId;
  const rawPath = data.path ?? data.title ?? '';

  let finalPath = '';

      // no parent -> use current path (normalized). If user provided an absolute path it will be normalized;
      // otherwise slug the value.
      if (parentId === null || parentId === undefined) {
        const cur = rawPath || data.title || '';
        finalPath = normalizePath(cur.startsWith('/') ? cur : '/' + slug(cur));
      } else {
        // find parent in loaded parentMenus
        const parent = parentMenus.find((m) => String(m.id) === String(parentId));
        // prefer parent's path if present, otherwise derive from parent's title
        let parentPath = parent?.path ?? (parent?.title ? '/' + slug(parent.title) : '');
        parentPath = parentPath ? parentPath.replace(/\/$/, '') : '';

       // for current, take rawPath but remove leading slash and slug it (preserve inner slashes)
        const curSegment = slug(rawPath || data.title || '');
        finalPath = normalizePath(parentPath + '/' + curSegment);
      }

      const payload = { ...data, path: finalPath };
      await update("permissionMenus", { id: data.id, data: payload });
      notify("Menu Updated", { type: "info" });
      redirect("list", "permissionMenus");
    } catch (error) {
      notify("Update Failed", { type: "error" });
    }
  };

  return (
    <Edit resource="permissionMenus">
      <SimpleForm sx={{ backgroundColor: "#ffffff", p: 3 }} onSubmit={handleSave}>
        <Box display="flex" flexWrap="wrap" gap={2}>
          <Box flex="1 1 48%">
            <TextInput source="title" label="Menu Name" fullWidth />
          </Box>

          <Box flex="1 1 48%">
            <TextInput source="path" label="Path (/xxx)" fullWidth />
          </Box>

          <Box flex="1 1 48%">
            <AutocompleteInput
              source="parentId"
              label="Parent Menu"
              choices={parentMenus}
              optionText="title"
              optionValue="id"
              fullWidth
            />
          </Box>

          {/* <Box flex="1 1 48%">
            <AutocompleteInput
              source="actionIds"
              label="Actions"
              choices={actions}
              optionText="actionName"
              optionValue="id"
              fullWidth
              multiple
            />
          </Box> */}

          <Box flex="1 1 48%">
            <TextInput source="icon" label="Icon" fullWidth />
          </Box>

          {/* <Box flex="1 1 48%">
            <TextInput source="order" label="Order" fullWidth />
          </Box> */}
        </Box>
      </SimpleForm>
    </Edit>
  );
};

export default MenuEdit;
